
import { Link, useLocation } from "react-router-dom";
import { SignOutButton } from "@/components/SignOutButton";
import { NavigationItem } from "./NavigationItems";

interface MobileNavigationMenuProps {
  items: NavigationItem[];
  menuOpen: boolean;
  onMenuItemClick: () => void;
}

export function MobileNavigationMenu({ 
  items, 
  menuOpen, 
  onMenuItemClick 
}: MobileNavigationMenuProps) {
  const location = useLocation();

  const isActive = (path: string) => {
    return location.pathname === path ? "text-primary bg-muted" : "text-muted-foreground";
  };

  if (!menuOpen) return null;

  return (
    <div className="md:hidden border-t bg-background">
      <div className="flex flex-col py-2 px-4 space-y-1 max-h-96 overflow-y-auto">
        {items.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            className={`${isActive(item.path)} px-3 py-3 text-sm rounded-md hover:bg-muted transition-colors flex items-center gap-3 mobile-touch-target`}
            onClick={onMenuItemClick}
          >
            <item.icon className="w-5 h-5" />
            <span className="font-medium">{item.label}</span>
          </Link>
        ))}
        <div className="pt-2 border-t">
          <SignOutButton onClick={onMenuItemClick} className="w-full justify-start px-3 py-3 mobile-touch-target" />
        </div>
      </div>
    </div>
  );
}
